<template>
    <div class="admin_box">
        <el-form label-position="top" label-width="80px" :model="form" ref="form" :rules="rules">
            <el-form-item label="新密码" prop="newPwd" >
                <el-input v-model="form.newPwd"  type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="resPwd">
                <el-input v-model="form.resPwd" type="password"></el-input>
            </el-form-item>


            <el-button class="btn" @click="Save">保存</el-button>

        </el-form>
    </div>
</template>

<script>
    import {
        newPwd
    } from '../api/api'
    import local from '../utils/local'

    export default {
        data() {
             var pwd = (rule, value, callback) => {
                if (!value.replace(/(^\s*)|(\s*$)/g, "")) {
                    return callback(new Error("请输入密码"));
                } else {
                    const reg = /^.{6,10}$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error("请输入6-10位密码"));
                    }
                }
            };
            return {
                form: {
                    newPwd: "",
                    resPwd: ''
                },
                rules: {
                    newPwd: [{
                            required: true,
                            validator: pwd,
                            trigger: "blur"
                        } // 非空

                    ],
                    resPwd: [{
                            required: true,
                            validator: pwd,
                            trigger: "blur"
                        } // 非空

                    ]
                }

            }
        },
        methods: {
            Save() {
                let id = local.get('admin_id');
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        newPwd(id, this.form.newPwd, this.form.resPwd).then(res => {
                            if (res.data.status == 200) {
                                this.$message({
                                    type: 'success',
                                    message: "修改成功"
                                })
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                    }
                })

            }
        }
    }
</script>

<style lang="less" scoped>
    .admin_box {
        padding: 0 50px;

        .el-form-item {
            // margin: 0;

            .el-form--label-top .el-form-item__label {
                padding: 0 !important;
            }

            .el-input {
                width: 800px;
            }

            .el-upload__tip {
                margin: 0;
            }

            .img {
                width: 110px;
            }

        }

        .btn {
            margin-top: 20px;
        }
    }
</style>